<script lang="ts">
    import { assets as assetPath} from "$app/paths";
    export let heading: string;
    export let list : {text: string, url: string}[];
    export let social : boolean = false;

</script>
<div class="footerList">
    <h4>{heading}</h4>
    {#if !social}
    <ul>
        {#each list as link}
            <li><a href={link.url} data-sveltekit-reload>{link.text}</a></li>
        {/each}
    </ul>
    {:else}
    <!-- Add links here -->
    <div class="footerList__social">
        <a data-sveltekit-reload href="https://twitter.com/offerzen"><img src={`${assetPath}/assets/social-icon-twitter.svg`} alt="Twitter social share logo"/></a>
        <a data-sveltekit-reload href="https://www.linkedin.com/company/offerzen/"><img src={`${assetPath}/assets/social-icon-linkedin.svg`} alt="Linkedin social share logo"/></a>
        <a data-sveltekit-reload href="https://www.facebook.com/offerzen"><img src={`${assetPath}/assets/social-icon-facebook.svg`} alt="Facebook social share logo"/></a>
    </div>
    {/if}
</div>
<style lang="postcss">

.footerList {

    & h4{
        margin-top:0;
        margin-bottom:5px;
        color:var(--color_offerzen_cerulean);
    }

    & ul {
        list-style: none;
        margin:0;
        padding:0;

        & li {
            padding: 6px 0;
            font-size:14px;

            & a {
                color: var(--color_grey_tertiary);
                font-weight: 400;
                line-height: 17px;
                text-decoration: none;

                &:hover {
                    color: var(--color_offerzen_cerulean)
                }
            }
        }
    }

    & .footerList__social {
        display: flex;
        gap:10px;
    }
}


</style>